export const connectProduct = {
  name: 'Connect',
  displayName: {
    source: {
      jsonPath: '$.displayName',
      resource: 'tenant',
    },
  },
  description:
    'Easily integrate Sitecore products with thousands of applications.',
  baseUrl: {
    dev: 'https://connect-dev.sitecore-staging.cloud',
    qa: 'https://connect-qa.sitecore-staging.cloud',
    staging: 'https://connect-staging.sitecore-staging.cloud',
    'pre-production': 'https://connect-beta.sitecorecloud.io',
    production: 'https://connect.sitecorecloud.io',
  },
  link: {
    type: 'external-link',
    to: '{baseUrl}/connect/dashboard/main?tenantId={tenantId}&organization={organizationId}',
    replacements: [
      {
        key: 'baseUrl',
        source: {
          jsonPath: "$.baseUrl['#env#']",
          resource: '_self',
        },
      },
      {
        key: 'tenantId',
        source: {
          resource: 'tenant',
          jsonPath: '$.id',
        },
      },
      {
        key: 'organizationId',
        source: {
          resource: 'tenant',
          jsonPath: '$.organizationId',
        },
      },
    ],
  },
  icon: {
    type: 'url',
    src: 'https://sitecorecontenthub.stylelabs.cloud/api/public/content/8ab39b3190204ee796622d8934d19f8b',
  },
  color: 'red',
  openInTab: true,
};
